import * as t from 'ts-schema';
import { defineMessage } from 'magpie-lib/models';
const navThemeSchema = t.object({
  itemHeight: t.number,
  groupHeight: t.number
});
const navTheme = defineMessage({
  type: 'nav-theme',
  payloadSchema: navThemeSchema
});
const getNavTheme = defineMessage({
  type: 'get-nav-theme',
  reply: navTheme
});
const changeNavTheme = defineMessage({
  type: 'change-nav-theme',
  payloadSchema: navThemeSchema,
  reply: navTheme
});
export const navThemeControls = {
  navTheme,
  getNavTheme,
  changeNavTheme
};